module.exports = __webpack_public_path__ + "assets/chart3.1.png?c04ddcf81249ed9254def27f6c12f3dd";